<template>
  <th scope="col" :class="{ 'is-num': isNumeric }" :title="description || null">
    <span class="pi-th">
      <span class="pi-th__label"><slot>{{ text }}</slot></span>
      <pi-definition-tooltip v-if="info || entry" :info-key="info" :entry="entry" :label="text" :align="isNumeric ? 'right' : 'left'"/>
    </span>
  </th>
</template>

<script>
import piDefinitionTooltip from "./piDefinitionTooltip.vue";

export default {
  name: "pi-th",
  components: { piDefinitionTooltip },
  props: {
    column: { type: Object, default: null },
    label: { type: String, default: "" },
    infoKey: { type: String, default: "" },
    entry: { type: Object, default: null },
    numeric: { type: Boolean, default: null },
  },
  computed: {
    source() {
      return this.column && typeof this.column === "object" ? this.column : {};
    },
    text() {
      return this.label || this.source.label || "";
    },
    info() {
      return this.infoKey || this.source.infoKey || "";
    },
    isNumeric() {
      return this.numeric === null ? this.source.numeric === true : this.numeric;
    },
    description() {
      return this.source.description || "";
    },
  },
};
</script>

<style src="./pi.css"></style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piTh.vue